module.exports = __webpack_public_path__ + "static/media/6.f0b1e647.png";